import React from 'react';
import logo from "../images/logo.png";
import image from "../images/image1.png";
import image4 from "../images/image2.png";
import image9 from "../images/image9.png";
import image6 from "../images/image6.png";
import image7 from "../images/image7.png";
import image5 from "../images/image5.png";
import DragImage2 from "../images/DragImage2.png";
import Footer from "../component/Footer";
import { IoIosArrowBack } from "react-icons/io";

function Blog() {
  const style = { color: "#ABAEC1", width: "184px", height: "52px", }
  return (
    <>

      <div className="Blog-container">

        <div className="LogoH1-Container">
          <div className="Back-Container">
            <a className="blog-back1" href="./" > < IoIosArrowBack />Back</a>
            <img className="" src={DragImage2} alt="" />
          </div>

          <div className="Logo2H1-Container">
            <img className="logo2" src={logo} style={style} alt='logo-image' />
            <h1 className="Blog-H">Learn the art of business management</h1>
          </div>
        </div>

        <div className="blog-main-container">

          <div className="Session1-container">
            <div className="image1-container">
              <img className="blog-image1" src={image} alt="" />
              <div className="Para-ReadMore-Con">
                <p className="Blog-p1">5 Essential Marketing Strategies for Small Business owners</p>
                <a href="#" className="readmore1">Read More</a>
              </div>
            </div>

            <div className="image2-container">
              <img className="blog-image1" src={image4} alt="" />
              <div className="Para-ReadMore-Con">
                <p className="Blog-p2">The Basics of Bookingkeeping and Accounting</p>
                <a href="#" className="readmore2">Read More</a>
              </div>
            </div>
          </div>

          <div className="Session2-container">
            <div className="image3-container">
              <img className="blog-image3" src={image9} alt="" />
              <div className="Para-ReadMore-Con">
                <p className="Blog-p3">How to Secure Funding for your Small Business</p>
                <a href="#" className="readmore3">Read More</a>
              </div>
            </div>

            <div className="image4-container">
              <img className="blog-image3" src={image5} alt="" />
              <div className="Para-ReadMore-Con">
                <p className="Blog-p4">Effective to Time Management for small Business Owners</p>
                <a href="#" className="readmore4">Read More</a>
              </div>
            </div>
          </div>

          <div className="Session3-container">
            <div className="image5-container">
              <img className="blog-image5" src={image6} alt="" />
              <div className="Para-ReadMore-Con">
                <p className="Blog-p5">Utilizing Technology to Boost Efficiency</p>
                <a href="#" className="readmore5">Read More</a>
              </div>
            </div>

            <div className="image6-container">
              <img className="blog-image6" src={image7} alt="" />
              <div className="Para-ReadMore-Con">
                <p className="Blog-p6">Building and Managing a Successful Team</p>
                <a href="#" className="readmore6">Read More</a>
              </div>
            </div>
          </div>
          <div className="Pagination-Container">
            <button className="btn-num1"><a href="./blog" className="num1">1</a></button>
            <button className="btn-num2"><a href="./blog2" className="num2">2</a></button>
          </div>
        </div>


      </div>

      <Footer />
    </>
  );
}

export default Blog;
